/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Error_AuthInputs */



/**
* | output |
* | --- |
* | "Please sign in again to use the AI Assistant." |
*
* @param {Assistant_Error_AuthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_error_auth = /** @type {((inputs?: Assistant_Error_AuthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Error_AuthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez vous reconnecter pour utiliser l'Assistant IA.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte melden Sie sich erneut an, um den KI-Assistenten zu nutzen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Effettua nuovamente l'accesso per utilizzare l'Assistente AI.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, войдите в систему еще раз, чтобы воспользоваться ИИ-помощником.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, inicie sesión de nuevo para usar el Asistente de IA.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请重新登录以使用人工智能助手。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントをご利用いただくには、再度ログインしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई असिस्टेंट का उपयोग करने के लिए कृपया दोबारा साइन इन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, faça login novamente para usar o Assistente de IA.")
	return /** @type {LocalizedString} */ ("Please sign in again to use the AI Assistant.")
});